export default __webpack_public_path__ + "assets/svg/no_announcements.18b5f8b3.svg";